import { installWorkerPool } from "@nova/webworker-pool/browser"

export const installTaskWorkers = () =>
    installWorkerPool({
        createWorker: () => new Worker(new URL("./tasks.worker", import.meta.url)),
    })
